import { Box } from '@ksyos/design-system';
import type { ServiceTypeWithServices } from '@common/interfaces/processStartWizard';
import { ServiceType } from '@common/enums';
import { translateKey } from '@frontend/translate';
import { NewProcessButton } from './NewProcessButton';
import { ProcessStartWizardButtonRowLayout } from './ProcessStartWizardButtonRowLayout';

function getButtonOrder(type: ServiceType): number | undefined {
    switch (type) {
        case ServiceType.examination:
            return 1;
        case ServiceType.counseling:
            return 2;
        case ServiceType.consultation:
            return 3;
        default:
            return 4;
    }
}

interface IServiceTypeButtonsProps {
    onClick: (name: any) => void;
    selectedServiceType?: ServiceType;
    serviceTypes: ServiceTypeWithServices[];
}

export function ServiceTypeButtons(props: IServiceTypeButtonsProps) {
    const { serviceTypes, onClick, selectedServiceType } = props;

    return (
        <ProcessStartWizardButtonRowLayout>
            {serviceTypes.map((item) => {
                return (
                    <Box
                        key={item.serviceType}
                        order={getButtonOrder(item.serviceType)}
                    >
                        <NewProcessButton
                            automation={`processFlowService-${item.serviceType}`}
                            data={{ name: item.serviceType }}
                            key={item.serviceType}
                            name={translateKey(`home.type_${item.serviceType}`)}
                            onClick={onClick}
                            previousSelection={selectedServiceType}
                        />
                    </Box>
                );
            })}
        </ProcessStartWizardButtonRowLayout>
    );
}
